export default {
  default: () => import("/Users/macgitlabrunner1/builds/EFFy8Dyq/5/web-applications/revagency-com/layouts/default.vue").then(m => m.default || m)
}